
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"itemUnpublishedFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MainItem"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"abstract"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"origin"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"funders"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"funderFragment"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"status"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"statusLabel"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"statusDate"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"title"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"version"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"versionRefs"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"itemId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"version"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"title"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"subjectId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"contentTypeId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"categoryIds"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"eventId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"communityId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"questionId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"licenseId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"keywords"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"external"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"hasCompetingInterests"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"competingInterestsDeclaration"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"gainedEthicsApproval"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"authors"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"authorFragment"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"isApprovedSpeaker"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"asset"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"assetFragment"},"directives":[]}]}},{"kind":"Field","alias":{"kind":"Name","value":"supplementaryAssets"},"name":{"kind":"Name","value":"suppItems"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"supplementaryFragment"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"webLinks"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"gid"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"title"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"description"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"url"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"termsAcceptance"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"createdById"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"gEditCount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"revisionNotes"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"revisionNoteFragment"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"versionNote"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"relatedContent"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"itemRelatedContentFragment"},"directives":[]}]}}]}}],"loc":{"start":0,"end":820}};
    doc.loc.source = {"body":"fragment itemUnpublishedFragment on MainItem {\n  __typename\n  id\n  abstract\n  origin\n\n  funders {\n    ...funderFragment\n  }\n\n  status\n  statusLabel\n  statusDate\n  title\n  version\n  versionRefs {\n    itemId\n    version\n    title\n  }\n  subjectId\n  contentTypeId\n  categoryIds\n  eventId\n  communityId\n  questionId\n  licenseId\n  keywords\n  external\n  hasCompetingInterests\n  competingInterestsDeclaration\n  gainedEthicsApproval\n\n  authors {\n    ...authorFragment\n  }\n\n  isApprovedSpeaker\n\n  asset {\n    ...assetFragment\n  }\n\n  supplementaryAssets: suppItems {\n    ...supplementaryFragment\n  }\n\n  webLinks {\n    gid\n    title\n    description\n    url\n  }\n\n  termsAcceptance\n  createdById\n  gEditCount\n\n  revisionNotes {\n    ...revisionNoteFragment\n  }\n  versionNote\n\n  relatedContent {\n    ...itemRelatedContentFragment\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["itemUnpublishedFragment"] = oneQuery(doc, "itemUnpublishedFragment");
        
